import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSignInAlt, FaUser, FaLock, FaEye, FaEyeSlash, FaTruck } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login, loading, error } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const colors = {
    primary: '#e28743',
    secondary: '#304a3f',
    light: '#e5e7eb',
    danger: '#ef4444'
  };

  const handleLogin = async (e) => {
    e.preventDefault();

    const result = await login(email, password);

    if (result?.success) {
      const role = result.user?.role;

      if (role === 'driver') {
        navigate('/driver-dashboard');
      } else {
        navigate('/dashboard');
      }
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4"
      style={{
        background: `linear-gradient(135deg, ${colors.secondary}, #1f3d32)`
      }}
    >
      <div className="max-w-md w-full bg-white/10 backdrop-blur-md rounded-xl p-8">
        
        {/* Header */}
        <div className="text-center mb-6">
          <div
            className="w-12 h-12 mx-auto mb-3 rounded-full flex items-center justify-center"
            style={{ backgroundColor: colors.primary }}
          >
            <FaTruck className="text-white text-xl" />
          </div>
          <h1 className="text-2xl font-bold text-white">FleetsCounty</h1>
          <p className="text-sm mt-1" style={{ color: colors.light }}>
            Sign in to your account
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleLogin} className="space-y-5">
          {/* Email */}
          <div>
            <label className="block text-sm text-white mb-2">Email</label>
            <div className="relative">
              <FaUser className="absolute left-3 top-3 text-gray-300" />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-3 py-3 rounded-lg bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-white"
                placeholder="Enter your email"
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label className="block text-sm text-white mb-2">Password</label>
            <div className="relative">
              <FaLock className="absolute left-3 top-3 text-gray-300" />
              <input
                type={showPassword ? 'text' : 'password'}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-10 py-3 rounded-lg bg-white/10 text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-white"
                placeholder="Enter your password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 text-gray-300"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </div>

          {/* Error */}
          {error && (
            <div
              className="p-3 rounded-lg text-sm"
              style={{ backgroundColor: colors.danger + '20', color: colors.danger }}
            >
              {error}
            </div>
          )}

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center py-3 rounded-lg text-white font-semibold transition hover:scale-105 disabled:opacity-50"
            style={{
              background: `linear-gradient(135deg, ${colors.primary}, #c46c2e)`
            }}
          >
            {loading ? 'Signing in...' : (
              <>
                <FaSignInAlt className="mr-2" />
                Sign In
              </>
            )}
          </button>
        </form>

        {/* Register */}
        <div className="text-center mt-6">
          <button
            onClick={() => navigate('/register')}
            className="text-sm hover:underline"
            style={{ color: colors.primary }}
          >
            Register (Company or Driver)
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login;
